const initialState = {
  data: [],
  errorMessage: null,
  availableFilters: {
    sources: [],
    rivers: [],
    types: [],
    locations: [],
    baseAlts: [],
    compAlts: [],
    favorites: []
  },
  favorites: true,
  initialVisit: true,
  source: null,
  loading: true,
  river: null,
  type: null,
  location: null,
  baseAlt: null,
  compAlt: null,
  startDate: '',
  endDate: '',
  loadingHeatMap: false,
  statsSummary: {
    x: '',
    y: '',
    z: '',
    zAbs: '',
    base: '',
    comp: '',
    baseText: '',
    compText: '',
    data: []
  },
  hoveredData: {
    x: '',
    y: '',
    z: ''
  }
};

const multi = ( state = initialState, action ) => {
	// must return the same state or an updated version of the state
	const actionLookup = {
    'POR_EDIT_STATE': () => {
      return {
        ...state,
        ...action.changes
      }
    }
  };
  return actionLookup[action.type] ? actionLookup[action.type](state, action) : {...state}; // if the action type exists, execute action, otherwise returns default state
};

export default multi;


// WEBPACK FOOTER //
// ./src/store/reducers/por.js